module.exports = __webpack_public_path__ + "static/media/LOJSND1.4527465b.png";